import React, { useState, useEffect } from 'react'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'
import { fadeIn } from '../variants'
import ReactImg from '../assets/logos/react.png'
import VueImg from '../assets/logos/vue.png'
import LaravelImg from '../assets/logos/laravel.png'
// import NodeImg from '../assets/logos/node.png'
import JavaScriptImg from '../assets/logos/javascript.png'
import TypeScriptImg from '../assets/logos/typescript.png'
import FramerImg from '../assets/logos/framer.png'
import RestImg from '../assets/logos/rest.png'
import AWSImg from '../assets/logos/aws.png'
import TailwindImg from '../assets/logos/tailwind.png'
import Resume from '../assets/Jasdev_Singh_Bedi_Resume_2026_Full_Stack_Developer.pdf';


const About = () => {
  const [hasTriggered, setHasTriggered] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0.1, // Lower threshold for mobile
    triggerOnce: false, // Allow retriggering to ensure it works
  });

  // Use useEffect to handle the trigger logic properly
  useEffect(() => {
    if (inView && !hasTriggered) {
      setHasTriggered(true);
    }
  }, [inView, hasTriggered]);
  return (
    <section id='about' className='section' ref={ref}>
      <div className='container mx-auto px-4'>
        {/* Text */}
        <motion.div
          variants={fadeIn('down', 0.3)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: true, amount: 0.3 }}
          className='flex-1 mb-8'>
          <div className='flex flex-col md:flex-row md:justify-between md:items-center mb-0'>
            <div className='md:pr-20 mb-6 md:mb-0'>
              <h2 className='h2 text-accent mr-auto'>About me.</h2>
              <h3 className='h3 mb-4'>I'm just a dude passionate about Technology and Design</h3>
              <p className='mb-8'>With 4+ years of working experience, 50+ projects completed including projects completed at software companies, freelance and in my own time. My Tech skills include: </p>
            </div>
            <div className='flex flex-col items-center md:items-end md:mr-4 md:mb-auto mb-8'>
              <div className='text-[40px] font-tertiary text-gradient mb-2 leading-tight text-center md:text-right'>
                {hasTriggered ? <CountUp start={0} end={4} duration={4} /> :
                  null}+
              </div>
              <div className='font-primary text-sm tracking-[2px] text-center md:text-right'>
                Years of <br />
                Experience
              </div>
            </div>
          </div>
        </motion.div>
        {/* Skills Badges */}
        {/* Mobile Carousel */}
        <div className="block lg:hidden mb-8 -mx-8">
          <div className="flex overflow-x-auto gap-4 px-8 pb-4 s- snap-x snap-mandatory scroll-ps-8 overflow-y-hidden hide-scrollbar">

            <div className="flex-shrink-0 w-[260px] snap-start">
              <h6 className='mb-6 font-bold text-center text-green-400'>Languages</h6>
              <div className="grid grid-cols-2 gap-4 border  border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] bg-black/20">
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={JavaScriptImg} alt="JavaScript" className="JavaScript h-[50px] object-contain" />
                  <span className="leading-tight text-sm">JavaScript</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={TypeScriptImg} alt="TypeScript" className="TypeScript h-[50px] object-contain" />
                  <span className="leading-tight text-sm">TypeScript</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg" alt="C++" className="h-[50px] object-contain" />
                  <span className="leading-tight text-sm">C++</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg" alt="C#" className="h-[50px] object-contain" />
                  <span className="leading-tight text-sm">C#</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" alt="HTML" className="h-[50px] object-contain" />
                  <span className="leading-tight text-sm">HTML</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" alt="CSS3" className="h-[50px] object-contain" />
                  <span className="leading-tight text-sm">CSS3</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-[260px] snap-start">
              <h6 className='mb-6 font-bold text-center text-green-400'>Frontend</h6>
              <div className="grid grid-cols-2 gap-4 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] bg-black/20">
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={ReactImg} alt="React Js" className="react h-[50px] object-contain" />
                  <span className="leading-tight text-sm">React Js</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={VueImg} alt="Vue Js" className="vue h-[50px] object-contain" />
                  <span className="leading-tight text-sm">Vue Js</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={LaravelImg} alt="Laravel PHP" className="laravel h-[50px] object-contain" />
                  <span className="leading-tight text-sm">Laravel PHP</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={FramerImg} alt="Framer" className="h-[50px] object-contain" />
                  <span className="leading-tight text-sm whitespace-nowrap">Framer</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" alt="Bootstrap" className="h-[50px] object-contain" />
                  <span className="leading-tight text-sm whitespace-nowrap">Bootstrap</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={TailwindImg} alt="Tailwind" className="tailwind h-[50px] object-contain" />
                  <span className="leading-tight text-sm whitespace-nowrap">Tailwind CSS</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-[260px] snap-start">
              <h6 className='mb-6 font-bold text-center text-green-400'>Backend and API</h6>
              <div className="grid grid-cols-2 gap-4 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] bg-black/20">
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node" className="node h-[50px] object-contain" />
                  <span className="leading-tight text-sm">Node JS</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" alt="Express" className="node h-[50px] object-contain invert opacity-50" />
                  <span className="leading-tight text-sm">Express JS</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.worldvectorlogo.com/logos/django.svg" alt="Django" className="node h-[40px] object-contain mt-auto mb-2" />
                  <span className="leading-tight text-sm">Django</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={RestImg} alt="Rest API" className="node h-[50px] object-contain mt-auto mb-2" />
                  <span className="leading-tight text-sm">Rest API</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://avatars.githubusercontent.com/u/54469796?s=200&v=4" alt="Supabase" className="node h-[45px] object-contain" />
                  <span className="leading-tight text-sm">Supabase</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://www.svgrepo.com/show/354202/postman-icon.svg" alt="Postman" className="node h-[45px] object-contain" />
                  <span className="leading-tight text-sm">Postman</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-[260px] snap-start">
              <h6 className='mb-6 font-bold text-center text-green-400'>Database</h6>
              <div className="grid grid-cols-2 gap-4 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] bg-black/20">
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" alt="MySQL" className="node h-[50px] object-contain brightness-150" />
                  <span className="leading-tight text-sm">MySQL</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL" className="node h-[50px] object-contain" />
                  <span className="leading-tight text-sm">PostgreSQL</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg" alt="SQLite" className="node h-[40px] object-contain mt-auto mb-3" />
                  <span className="leading-tight text-sm">SQLite</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" alt="Firebase" className="node h-[45px] object-contain mt-auto mb-3" />
                  <span className="leading-tight text-sm">Firebase</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" alt="Redis" className="node h-[50px] object-contain mt-auto mb-2" />
                  <span className="leading-tight text-sm">Redis</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://avatars.githubusercontent.com/u/54469796?s=200&v=4" alt="Supabase" className="node h-[45px] object-contain" />
                  <span className="leading-tight text-sm">Supabase</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-[260px] snap-start">
              <h6 className='mb-6 font-bold text-center text-green-400'>Cloud & DevOps</h6>
              <div className="grid grid-cols-2 gap-4 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] bg-black/20">
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src={AWSImg} alt="AWS" className="h-[55px] object-contain" />
                  <span className="leading-tight text-sm">AWS</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg" alt="Azure" className="h-[40px] object-contain" />
                  <span className="leading-tight text-sm">Azure</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" alt="Docker" className="h-[60px] object-contain " />
                  <span className="leading-tight text-sm">Docker</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px]">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="Git" className="h-[45px] object-contain mt-auto mb-3" />
                  <span className="leading-tight text-sm">Git</span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px] opacity-0">
                  <img src="#" alt="-" className="node h-[45px] object-contain mt-auto mb-3 opacity-0" />
                  <span className="leading-tight text-sm opacity-0"></span>
                </div>
                <div className="flex flex-col items-center justify-between text-center h-[80px] opacity-0">
                  <img src="#" alt="-" className="node h-[45px] object-contain mt-auto mb-3 opacity-0" />
                  <span className="leading-tight text-sm opacity-0"></span>
                </div>
              </div>
            </div>

            {/* Spacer to show peek effect */}
            <div className="flex-shrink-0 w-8"></div>
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden lg:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-8 mb-0">
          <motion.div
            variants={fadeIn('up', 0.5)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}>
            <h6 className='mb-6 font-bold text-center text-green-400'>Languages</h6>
            <div className="grid grid-cols-2 gap-6 mb-12 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%]">
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={JavaScriptImg} alt="JavaScript" className="JavaScript h-[50px] object-contain" />
                <span className="leading-tight text-sm">JavaScript</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={TypeScriptImg} alt="TypeScript" className="TypeScript h-[50px] object-contain" />
                <span className="leading-tight text-sm">TypeScript</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg" alt="C++" className="h-[50px] object-contain" />
                <span className="leading-tight text-sm">C++</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg" alt="C#" className="h-[50px] object-contain" />
                <span className="leading-tight text-sm">C#</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" alt="HTML" className="h-[50px] object-contain" />
                <span className="leading-tight text-sm">HTML</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" alt="CSS3" className="h-[50px] object-contain" />
                <span className="leading-tight text-sm">CSS3</span>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={fadeIn('up', 0.6)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}>
            <h6 className='mb-6 font-bold text-center text-green-400'>Frontend</h6>
            <div className="grid grid-cols-2 gap-6 mb-12 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] h-100%">
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={ReactImg} alt="React Js" className="react h-[50px] object-contain" />
                <span className="leading-tight text-sm">React Js</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={VueImg} alt="Vue Js" className="vue h-[50px] object-contain" />
                <span className="leading-tight text-sm">Vue Js</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={LaravelImg} alt="Laravel PHP" className="laravel h-[50px] object-contain" />
                <span className="leading-tight text-sm">Laravel PHP</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={FramerImg} alt="Framer" className="h-[50px] object-contain" />
                <span className="leading-tight text-sm whitespace-nowrap">Framer</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" alt="Bootstrap" className="h-[50px] object-contain" />
                <span className="leading-tight text-sm whitespace-nowrap">Bootstrap</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={TailwindImg} alt="Tailwind" className="tailwind h-[35px] object-contain" />
                <span className="leading-tight text-sm whitespace-nowrap">Tailwind CSS</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            variants={fadeIn('up', 0.7)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}>
            <h6 className='mb-6 font-bold text-center text-green-400'>Backend and API</h6>
            <div className="grid grid-cols-2 gap-6 mb-12 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] h-100%">
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node" className="node h-[50px] object-contain" />
                <span className="leading-tight text-sm">Node JS</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" alt="Express" className="node h-[50px] object-contain invert opacity-50" />
                <span className="leading-tight text-sm">Express JS</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.worldvectorlogo.com/logos/django.svg" alt="Django" className="node h-[40px] object-contain mt-auto mb-2" />
                <span className="leading-tight text-sm">Django</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={RestImg} alt="Rest API" className="node h-[50px] object-contain mt-auto mb-2" />
                <span className="leading-tight text-sm">Rest API</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://avatars.githubusercontent.com/u/54469796?s=200&v=4" alt="Supabase" className="node h-[45px] object-contain" />
                <span className="leading-tight text-sm">Supabase</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://www.svgrepo.com/show/354202/postman-icon.svg" alt="Postman" className="node h-[45px] object-contain" />
                <span className="leading-tight text-sm">Postman</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            variants={fadeIn('up', 0.8)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}>
            <h6 className='mb-6 font-bold text-center text-green-400'>Database</h6>
            <div className="grid grid-cols-2 gap-6 mb-12 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] h-100%">
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" alt="MySQL" className="node h-[50px] object-contain brightness-150" />
                <span className="leading-tight text-sm">MySQL</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL" className="node h-[50px] object-contain" />
                <span className="leading-tight text-sm">PostgreSQL</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg" alt="SQLite" className="node h-[40px] object-contain mt-auto mb-3" />
                <span className="leading-tight text-sm">SQLite</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" alt="Firebase" className="node h-[45px] object-contain mt-auto mb-3" />
                <span className="leading-tight text-sm">Firebase</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" alt="Redis" className="node h-[50px] object-contain mt-auto mb-2" />
                <span className="leading-tight text-sm">Redis</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://avatars.githubusercontent.com/u/54469796?s=200&v=4" alt="Node" className="node h-[45px] object-contain" />
                <span className="leading-tight text-sm">Supabase</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            variants={fadeIn('up', 0.9)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}>
            <h6 className='mb-6 font-bold text-center text-green-400'>Cloud & DevOps</h6>
            <div className="grid grid-cols-2 gap-6 mb-12 border border-green-400 rounded-lg p-4 hover:bg-green-800 transition-all duration-300 hover:scale-[102%] h-100%">
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src={AWSImg} alt="AWS" className="h-[55px] object-contain" />
                <span className="leading-tight text-sm">AWS</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg" alt="Azure" className="h-[40px] object-contain" />
                <span className="leading-tight text-sm">Azure</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" alt="Docker" className="h-[60px] object-contain " />
                <span className="leading-tight text-sm">Docker</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px]">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="Git" className="h-[45px] object-contain mt-auto mb-3" />
                <span className="leading-tight text-sm">Git</span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px] opacity-0">
                <img src="#" alt="-" className="node h-[45px] object-contain mt-auto mb-3 opacity-0" />
                <span className="leading-tight text-sm opacity-0"></span>
              </div>
              <div className="flex flex-col items-center justify-between text-center h-[80px] opacity-0">
                <img src="#" alt="-" className="node h-[45px] object-contain mt-auto mb-3 opacity-0" />
                <span className="leading-tight text-sm opacity-0"></span>
              </div>
            </div>
          </motion.div>

        </div>

        {/* Stats */}
        {/* <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                  {inView ? <CountUp start={0} end={3} duration={5} /> :
                    null}+
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Years of <br />
                  Experience
                </div>
              </div>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                  {inView ? <CountUp start={0} end={50} duration={3} /> :
                    null}+
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Projects <br />
                  Completed
                </div>
              </div>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                  {inView ? <CountUp start={0} end={20} duration={3} /> :
                    null}+
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Software <br />
                  Skills
                </div>
              </div>
            </div> */}
        <motion.div
          variants={fadeIn('up', 1.0)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: true, amount: 0.3 }} className='md:flex gap-5 items-end'>
          <div className='flex flex-col lg:flex-row items-center lg:gap-8 ml-auto'>
            <a
              href={Resume}
              target="_blank"
              rel="noreferrer"
              className='btn btn_accent btn-sm flex items-center hover:animate-pulse whitespace-nowrap mb-5 md:mb-0'>My Resume</a>
            <a
              href="tel:+61492917957"
              target="_blank"
              rel="noreferrer"
              className='btn btn_secondary btn-sm  border-2 border-none bg-none text-white hover:bg-accent hover:text-white transition-all flex items-center hover:animate-pulse whitespace-nowrap ease-in-out duration-700'>
              Contact me
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About
